function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00781 6C6.45553 6 6.00781 6.44772 6.00781 7V9C6.00781 9.55229 6.45553 10 7.00781 10H9.00781C9.5601 10 10.0078 9.55229 10.0078 9V7C10.0078 6.44772 9.5601 6 9.00781 6H7.00781Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0078 2C12.0078 1.44772 12.4555 1 13.0078 1C13.5601 1 14.0078 1.44772 14.0078 2C14.5601 2 15.0078 2.44772 15.0078 3C15.0078 3.55228 14.5601 4 14.0078 4V12C14.5601 12 15.0078 12.4477 15.0078 13C15.0078 13.5523 14.5601 14 14.0078 14C14.0078 14.5523 13.5601 15 13.0078 15C12.4555 15 12.0078 14.5523 12.0078 14H4.00781C4.00781 14.5523 3.5601 15 3.00781 15C2.45553 15 2.00781 14.5523 2.00781 14C1.45553 14 1.00781 13.5523 1.00781 13C1.00781 12.4477 1.45553 12 2.00781 12L2.00781 4C1.45553 4 1.00781 3.55228 1.00781 3C1.00781 2.44772 1.45553 2 2.00781 2C2.00781 1.44772 2.45553 1 3.00781 1C3.5601 1 4.00781 1.44772 4.00781 2L12.0078 2ZM12.0078 12H4.00781V4H12.0078V12Z",
  fill: "#121212"
});

function SvgAcres(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcres);
export default __webpack_public_path__ + "static/media/Acres.deee0b77.svg";
export { ForwardRef as ReactComponent };